import React from 'react';
import './footer.css';
import logo from '../components/logo512.png';
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faInstagram, faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

library.add(
  faLinkedinIn,
    faTwitter,
    faInstagram
  );

const Footer = (props) => {
    return (
        <div className="footer" id="flex">
            <div className='footer-content'>
                <div className='footer-logo'><img src={logo} alt='logo'/></div>
            
                <div className='footer-links'><h2>Need help?</h2>
                    <div className='footer-Actual-links'>
                  <a href='#get-started-area'>Terms &amp; Conditions</a>
                  <a href='#get-started-area'>Privacy Policy</a> </div>
                  
                </div>
                <div className='footer-links'><h2>Contact</h2>
                    <div className='footer-Actual-links'>
                    <p>Address: Nigeria.</p>
              <p>Phone: +2348109785112</p>
              <p>Email: <a href="mailto:">oguntadetweed1@gmail.com</a></p>
                  </div>
                </div>
                <div className='footer-links' id ="abeg-work"><h2>Social Media</h2>
                <ul className="social-menu">
                <li className="list-inline-item"><a href="https://www.linkedin.com/in/tawheed-oguntade-88ba9b1a2/"><FontAwesomeIcon icon={faLinkedinIn}  /></a></li>
                <li className="list-inline-item"><a href="https://twitter.com/MuhamaduTawheed"><FontAwesomeIcon icon={faTwitter}  /></a></li>
                <li className="list-inline-item"><a href="https://wa.me/+2348109785112"><FontAwesomeIcon icon={faWhatsapp}  /></a></li>
                
              </ul>
                </div>
            </div>
          <div className='footer-bottom'><a href="https://www.github.com/TWEEDOriginal"> &copy; TweedOriginal Design | ©2020 Created by Tawheed Oguntade.</a></div>
        </div>
       
    )
    };
    
export default Footer;